import { createDialogQueue } from '@rmwc/dialog';

// eslint-disable-next-line import/prefer-default-export
export const queue = createDialogQueue();